import React, { useEffect } from "react"
import { Helmet } from "react-helmet"
import { openCalBookingModal } from "./CalBookingLink"
import { SignUpModalHost } from "./SignUpLink"

function openModalFromQueryParam(param, openModal) {
  const currentUrl = new URL(window.location.href)
  if (currentUrl.searchParams.get(param) !== "1") return

  openModal()
  currentUrl.searchParams.delete(param)
  window.history.replaceState(
    window.history.state,
    "",
    `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`
  )
}

function OpenDemoModal() {
  useEffect(() => {
    openModalFromQueryParam("openDemo", openCalBookingModal)
  }, [])

  return null
}

export default function Layout({ children }) {
  return (
    <>
      <Helmet>
        <link rel="stylesheet" href="/css/signup-modal.css?v=5" type="text/css" />
        <script dangerouslySetInnerHTML={{
          __html: `
            function isiOS() {
              return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
              ].includes(navigator.platform)
                || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
            }
            function isAndroid() {
              return /Android|Opera Mini/i.test(navigator.userAgent);
            }
          `
        }} />
        <script dangerouslySetInnerHTML={{
          __html: `
            if (window.location.host.includes('collar.app') && (isiOS() || isAndroid())) {
              window.location.pathname = '/download';
            }
          `
        }} />
        <script dangerouslySetInnerHTML={{
          __html: `
            (function(h,o,t,j,a,r){
                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid:3308705,hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
          `
        }} />
        <script dangerouslySetInnerHTML={{
          __html: `
            (function () {
              var s = document.createElement('script');
              s.type = 'text/javascript';
              s.async = true;
              s.src = 'https://app.termly.io/embed.min.js';
              s.id = 'b1f64cff-41ab-46f6-9dc8-81f6b02f6233';
              s.setAttribute("data-name", "termly-embed-banner");
              var x = document.getElementsByTagName('script')[0];
              x.parentNode.insertBefore(s, x);
            })();
          `
        }} />
        <script dangerouslySetInnerHTML={{
          __html: `
            (function(d, w, c) {
                w.BrevoConversationsID = '64c3c77cb2f63644900a5803';
                w[c] = w[c] || function() {
                    (w[c].q = w[c].q || []).push(arguments);
                };
                var s = d.createElement('script');
                s.async = true;
                s.src = 'https://conversations-widget.brevo.com/brevo-conversations.js';
                if (d.head) d.head.appendChild(s);
            })(document, window, 'BrevoConversations');
          `
        }} />

        <style dangerouslySetInnerHTML={{
          __html: `
            .navbar-large, .sticky-ct-container, .navbar-mobile {
              backdrop-filter: blur(2em);
              -webkit-backdrop-filter: blur(2em);
            }
          `
        }} />
      </Helmet>
      {children}
      <OpenDemoModal />
      <SignUpModalHost />
    </>
  )
}
